import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Corrected the import path for App
import reportWebVitals from './reportWebVitals'; // Corrected the import path for reportWebVitals
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
